// @module Videos
define('Videos.View'
	, [
		'Videos.Cell.View'

		, 'videos.tpl'

		, 'Backbone'
	]
	, function (
		VideosCellView

		, videos_tpl

		, Backbone
	) {
		'use strict';

		// @class Videos.View @extends Backbone.View
		return Backbone.View.extend({

			template: videos_tpl

			, title: 'Sunshine Supply Videos'

			, initialize: function (options) {
				this.collection = options.collection;
			}

			, beforeShowContent: function () {
				return this.collection.fetch();
			}

			, childViews: {
				'Videos.Collection': function () {
					return new VideosCellView({
						collection: this.collection
					})
				}
			}

			//@method getContext @return Videos.View.Context
			, getContext: function getContext() {
				//@class Videos.View.Context
				return {
				};
			}
		});
	});
